import { P } from '@components/Typography';
import { StatTitle } from '@pages/EventHome/components/EventParticipationSection/styles';
import styled from 'styled-components';

export const TicketsItemsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(330px, 330px));
  gap: 3rem;
  justify-content: center;
  width: 100%;
`;

export const FooterCard = styled.div`
  display: grid;
  place-items: center;
  padding: 0 4rem 2.5rem 4rem;
  height: 10rem;
  border-bottom-right-radius: 1.2rem;
  border-bottom-left-radius: 1.2rem;
`;

export const TopBodyRoot = styled.div`
  display: grid;
  grid-template-rows: 1fr auto;
  width: 100%;
  grid-gap: 1rem;
  height: 100%;
`;

export const HeaderContainer = styled.div`
  padding: 2.5rem 4rem 1rem 4rem;
  display: grid;
  place-items: center;
  grid-gap: 1.2rem;
`;

export const Title = styled(StatTitle)`
  color: ${({ theme }) => theme.color.mobilityGrey};
  font-size: ${({ theme }) => theme.fontSize.size35};
  font-weight: ${({ theme }) => theme.fontWeight.weight900};
  line-height: ${({ theme }) => theme.lineHeight.height125};
  word-break: normal;
  white-space: normal;
  text-align: center;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: ${({ theme }) => theme.fontSize.size26};
    line-height: ${({ theme }) => theme.lineHeight.height140};
  }
`;

export const FurtherInformationText = styled(P)<{
  $color: string;
  $backgroundColor?: string;
}>`
  color: ${({ $color }) => $color};
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  padding: 0.6rem 3rem;
  border-radius: 0.8rem;
  white-space: nowrap;
  transition: color 600ms cubic-bezier(0.4, 0.47, 0.13, 0.88);
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: ${({ theme }) => theme.fontSize.size18};
  }
`;

export const UnderlineContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    justify-content: flex-start;
  }
`;

export const Underline = styled.div<{
  color?: string;
}>`
  width: 163px;
  height: 0.4rem;
  background-color: ${({ color, theme }) => color || theme.color.white};
`;

export const PriceText = styled.div<{ color?: string }>`
  color: ${({ color, theme }) => color || theme.color.mobilityGrey};
  font-size: ${({ theme }) => theme.fontSize.size35};
  font-weight: ${({ theme }) => theme.fontWeight.weight700};
  line-height: ${({ theme }) => theme.lineHeight.height135};
  text-align: center;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    font-size: ${({ theme }) => theme.fontSize.size26};
    font-weight: ${({ theme }) => theme.fontWeight.weight400};
  }
`;
